import { createContext, useContext, type ReactNode } from "react";

// 목록 화면(표/그리드) 안의 깊은 컴포넌트가 prop 드릴 없이 목록을 다시 조회하도록 요청하는 seam 이다.
// 프로바이더가 주는 refresh 는 보통 목록 source 의 refresh() 다. 이 함수는 현재 페이지 전체를 다시 조회한다.
// 프로바이더 밖(상세 Window 처럼 목록이 없는 곳)에서는 no-op 이다. 그래서 소비처는 안전하게 호출할 수 있다.
const ListRefreshContext = createContext<() => void>(() => {});

export function ListRefreshProvider({
  refresh,
  children,
}: {
  refresh: () => void;
  children: ReactNode;
}): ReactNode {
  return <ListRefreshContext.Provider value={refresh}>{children}</ListRefreshContext.Provider>;
}

// 감싸는 목록에 다시 조회하도록 요청한다. 프로바이더가 없으면 no-op 을 반환한다.
export function useListRefresh(): () => void {
  return useContext(ListRefreshContext);
}
